import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export enum Mode {
    VIEW = 'view',
    CREATE = 'create',
    UPDATE = 'edit',
}

/**
 * Хук для определения текущего режима страницы на основе последнего сегмента URL.
 *
 * @returns {Mode} Один из режимов: Mode.VIEW, Mode.CREATE или Mode.UPDATE.
 *
 * @example
 * const mode = useMode();
 * if (mode === Mode.CREATE) {
 *   // показать форму создания
 * }
 */
export const useMode = (): Mode => {
    const { pathname } = useLocation();

    return useMemo(() => {
        const segments = pathname.toLowerCase().split('/').filter(Boolean);
        const lastSegment = segments.at(-1);

        switch (lastSegment) {
            case Mode.CREATE:
                return Mode.CREATE;
            case Mode.UPDATE:
                return Mode.UPDATE;
            default:
                return Mode.VIEW;
        }
    }, [pathname]);
};
